import { CommonWrap, ComomonAlert } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box } from "@mui/material";
import { useLocales } from "@/locales";
import CodeSnippet from "@/components/CodeSnippet";
import ShowTable from "@/DocLayout/Table/index";
import { CREATE_INVOCIE_API_URL } from "@/config";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import { useContext } from "react";
import PostRequest from "@/components/PostRequest";
import { Trans } from "react-i18next";
import Table from "@/DocLayout/Table/index";

export default function InvoiceAPI({ url: INVOICE_CREATE_ }: { url: string }) {
  const { translate, currentLang } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  const invoice_api = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
        "invoiceUrl": "https://i.ccpayment.com/xxx"
    }
}`,
    go: {
      http_ex_code: `package main

import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "encoding/json"
    "fmt"
    "io/ioutil"
    "net/http"
    "strconv"
    "time"
)

func main() {
    appID := "*** your app_id ***"
    appSecret := "*** your app_secret ***"
    url := "${INVOICE_CREATE_}"

    // Construct request payload as a map
    content := map[string]string{
        "orderId":    strconv.FormatInt(time.Now().Unix(), 10),
        "price":      "1",
        "priceCoinId": "1280",
        // Optional fields
        // "priceFiatId": "1033",
        // "product": "test",
        // "returnUrl": "",
        // "buyerEmail": "",
        // "expiredAt": ""
    }

    // Get current timestamp in seconds
    timestamp := strconv.FormatInt(time.Now().Unix(), 10)

    // Marshal the content map into a JSON string
    bodyBytes, err := json.Marshal(content)
    if err != nil {
        fmt.Println("Error marshaling content:", err)
        return
    }
    body := string(bodyBytes)

    signText := appID + timestamp
    if len(body) != 2 {
        signText += body
    } else {
        body = ""
    }

    serverSign := generateHMACSHA256(signText, appSecret)

    req, err := http.NewRequest("POST", url, bytes.NewBuffer([]byte(body)))
    if err != nil {
        fmt.Println("Error creating request:", err)
        return
    }

    req.Header.Set("Content-Type", "application/json;charset=utf-8")
    req.Header.Set("Appid", appID)
    req.Header.Set("Sign", serverSign)
    req.Header.Set("Timestamp", timestamp)

    client := &http.Client{}
    resp, err := client.Do(req)
    if err != nil {
        fmt.Println("Error making request:", err)
        return
    }
    defer resp.Body.Close()

    bodyResp, err := ioutil.ReadAll(resp.Body)
    if err != nil {
        fmt.Println("Error reading response:", err)
        return
    }

    fmt.Println("Response:", string(bodyResp))
}

func generateHMACSHA256(data, secret string) string {
    key := []byte(secret)
    h := hmac.New(sha256.New, key)
    h.Write([]byte(data))
    return hex.EncodeToString(h.Sum(nil))
}
`,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `import org.json.JSONObject;

import javax.crypto.Mac;
import javax.crypto.spec.SecretKeySpec;
import java.net.HttpURLConnection;
import java.net.URL;
import java.nio.charset.StandardCharsets;
import java.util.Scanner;

public class createInvoiceUrl {
public static void main(String[] args) {
    try {
        String appId = "*** your app_id ***";
        String appSecret = "*** your app_secret ***";
        String url = "${INVOICE_CREATE_}";

        // Construct the JSON content
        JSONObject content = new JSONObject();
        content.put("orderId", String.valueOf(System.currentTimeMillis() / 1000));
        content.put("price", "1");
        content.put("priceCoinId", "1280");
        // Optional fields
        // content.put("priceFiatId", "1033");
        // content.put("product", "test");
        // content.put("returnUrl", "");
        // content.put("buyerEmail", "");
        // content.put("expiredAt", "");

        // Get current timestamp
        long timestamp = System.currentTimeMillis() / 1000;
        String body = content.toString();
        String signText = appId + timestamp;

        // Append body to signText if body length is not 2
        if (body.length() != 2) {
            signText += body;
        } else {
            body = "";
        }

        // Generate HMAC SHA256 signature
        String serverSign= generateHMACSHA256Signature(signText,appSecret);

        // Make the POST request
        URL apiUrl = new URL(url);
        HttpURLConnection connection = (HttpURLConnection) apiUrl.openConnection();
        connection.setRequestMethod("POST");
        connection.setRequestProperty("Content-Type", "application/json;charset=utf-8");
        connection.setRequestProperty("Appid", appId);
        connection.setRequestProperty("Sign", serverSign);
        connection.setRequestProperty("Timestamp", String.valueOf(timestamp));
        connection.setDoOutput(true);

        // Write request body if not empty
        if (!body.isEmpty()) {
            connection.getOutputStream().write(body.getBytes(StandardCharsets.UTF_8));
        }

        // Get the response
        int responseCode = connection.getResponseCode();
        if (responseCode == HttpURLConnection.HTTP_OK) {
            Scanner scanner = new Scanner(connection.getInputStream());
            StringBuilder response = new StringBuilder();
            while (scanner.hasNext()) {
                response.append(scanner.nextLine());
            }
            scanner.close();

            // Parse and print JSON response
            JSONObject jsonResponse = new JSONObject(response.toString());
            System.out.println(jsonResponse.toString(4));  // Pretty print
        } else {
            System.out.println("Error: " + responseCode);
        }

    } catch (Exception e) {
        e.printStackTrace();
    }
}

public static String generateHMACSHA256Signature(String data, String key) throws Exception {
    Mac mac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKeySpec = new SecretKeySpec(key.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    mac.init(secretKeySpec);


    byte[] rawHmac = mac.doFinal(data.getBytes(StandardCharsets.UTF_8));
    StringBuilder hexString = new StringBuilder();
    for (byte b : rawHmac) {
        String hex = Integer.toHexString(0xff & b);
        if (hex.length() == 1) {
            hexString.append('0');
        }
        hexString.append(hex);
    }

    return hexString.toString();
}
}`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `import json
import time
import hmac
import hashlib
import binascii
import requests

app_id = "*** your app_id ***"
app_secret = "*** your app_secret ***"
url = "${INVOICE_CREATE_}"
content = {
    "orderId": str(int(time.time())),
    "price": "1",
    "priceCoinId": "1280",
    # "priceFiatId": "1033",
    # "product": "test",
    # "returnUrl": "",
    # "buyerEmail": "",
    # "expiredAt": ""
}

timestamp = int(time.time())
body = json.dumps(content)
sign_text = f"{app_id}{timestamp}"
if len(body) != 2:
  sign_text = f"{sign_text}{body}"
else:
  body = ""

h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
server_sign = binascii.hexlify(h.digest()).decode('utf-8')

res = requests.post(url=url,
  headers={
    "Content-Type": "application/json;charset=uf8",
    "Appid": app_id,
    "Sign": server_sign,
    "Timestamp": f"{timestamp}"},
  data=body
  )
print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const crypto = require('crypto');
const axios = require('axios');

// Configuration variables
const appID = "*** your app_id ***";
const appSecret = "*** your app_secret ***";
const url = "${INVOICE_CREATE_}";

// Build request body
const content = {
    orderId: String(Math.floor(Date.now() / 1000)), // Current timestamp in seconds
    price: "1",
    priceCoinId: "1280",
    // Optional fields
    // priceFiatId: "1033",
    // product: "test",
    // returnUrl: "",
    // buyerEmail: "",
    // expiredAt: ""
};

// Get the current timestamp (in seconds)
const timestamp = Math.floor(Date.now() / 1000);

// Convert the content object to a JSON string
let body = JSON.stringify(content);

// Create the signature base string
let signText = appID + timestamp;
if (body.length !== 2) { // Check if the body is an empty object
    signText += body;
} else {
    body = "";
}

// Generate HMAC SHA256 signature
function generateHMACSHA256(data, secret) {
    return crypto.createHmac('sha256', secret).update(data).digest('hex');
}

const serverSign = generateHMACSHA256(signText, appSecret);

// Set HTTP request headers
const headers = {
    'Content-Type': 'application/json;charset=utf-8',
    'Appid': appID,
    'Sign': serverSign,
    'Timestamp': timestamp
};

// Send the HTTP POST request
axios.post(url, body, { headers })
    .then(response => {
        console.log("Response:", response.data);
    })
    .catch(error => {
        console.error("Error making request:", error.message);
    });
`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `const crypto = require('crypto');
const axios = require('axios');

// Configuration variables
const appID = "*** your app_id ***";
const appSecret = "*** your app_secret ***";
const url = "${INVOICE_CREATE_}";

// Build request body
const content = {
    orderId: String(Math.floor(Date.now() / 1000)), // Current timestamp in seconds
    price: "1",
    priceCoinId: "1280",
    // Optional fields
    // priceFiatId: "1033",
    // product: "test",
    // returnUrl: "",
    // buyerEmail: "",
    // expiredAt: ""
};

// Get the current timestamp (in seconds)
const timestamp = Math.floor(Date.now() / 1000);

// Convert the content object to a JSON string
let body = JSON.stringify(content);

// Create the signature base string
let signText = appID + timestamp;
if (body.length !== 2) { // Check if the body is an empty object
    signText += body;
} else {
    body = "";
}

// Generate HMAC SHA256 signature
function generateHMACSHA256(data, secret) {
    return crypto.createHmac('sha256', secret).update(data).digest('hex');
}

const serverSign = generateHMACSHA256(signText, appSecret);

// Set HTTP request headers
const headers = {
    'Content-Type': 'application/json;charset=utf-8',
    'Appid': appID,
    'Sign': serverSign,
    'Timestamp': timestamp
};

// Send the HTTP POST request
axios.post(url, body, { headers })
    .then(response => {
        console.log("Response:", response.data);
    })
    .catch(error => {
        console.error("Error making request:", error.message);
    });
`,
      example_code: ``,
      example_code2: ``,
    },
  };
  return (
    <>
      {/* invoice - API  invoice相关API*/}
      <ContentWrap
        id="invoice-api"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0" id="invoice-api">
              {translate("merchant_app_mode_API.text_141")}
            </Box>

            <Box className="desc">
              {translate("merchant_app_mode_API.text_142")}
            </Box>
            {currentLang?.value !== "en" && (
              <Box className="desc">
                {translate("merchant_app_mode_API.text_143")}
              </Box>
            )}
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={CREATE_INVOCIE_API_URL} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_app_mode_API.text_144")}`,
                },
                {
                  name: "product",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_app_mode_API.text_145")}`,
                },
                {
                  name: "returnUrl",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_146"
                        )} ` as any,
                      }}
                    />
                  ),
                },
                {
                  name: "price",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_147"
                        )} ` as any,
                      }}
                    />
                  ),
                },
                {
                  name: "priceFiatId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc:
                    currentLang.value !== "en" ? (
                      <div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: `${translate(
                              "merchant_app_mode_API.text_148"
                            )} ` as any,
                          }}
                        />

                        <div style={{ display: "flex" }}>
                          <Trans
                            i18nKey={"merchant_app_mode_API.text_148_"}
                            t={translate as any}
                          >
                            Just a placeholder
                            <a href={"#get-fiat-list"} className="link">
                              Just a placeholder
                            </a>
                          </Trans>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: `${translate(
                                "merchant_app_mode_API.text_148_1"
                              )} ` as any,
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div>
                        <Trans
                          i18nKey={"merchant_app_mode_API.text_148"}
                          t={translate as any}
                        >
                          Just a placeholder
                          <a href={"#get-fiat-list"} className="link">
                            Just a placeholder
                          </a>
                        </Trans>
                      </div>
                    ),
                },
                {
                  name: "priceCoinId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc:
                    currentLang.value !== "en" ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `${translate(
                            "merchant_app_mode_API.text_149"
                          )} ` as any,
                        }}
                      />
                    ) : (
                      <div>
                        <Trans
                          i18nKey={"merchant_app_mode_API.text_149"}
                          t={translate as any}
                        >
                          Just a placeholder
                          <a href={"#get-token-list"} className="link">
                            Just a placeholder
                          </a>
                        </Trans>
                      </div>
                    ),
                },
                {
                  name: "expiredAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <Trans
                      i18nKey={"merchant_app_mode_API.text_150"}
                      t={translate as any}
                    >
                      Just a placeholder
                      <a
                        href={
                          "https://console.ccpayment.com/merchatsetting/menu/settings"
                        }
                        className="link"
                      >
                        Just a placeholder
                      </a>
                    </Trans>
                  ),
                },
                {
                  name: "buyerEmail",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_app_mode_API.text_151")}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate("merchant_app_mode_API.text_152"),
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={invoice_api[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 返回参数 */}

      <ContentWrap
        leftChildrenSx={{
          paddingTop: "2px",
        }}
        leftChildren={
          <CommonWrap>
            <Box component={"div"} className="title_1" mt={3}>
              {translate("common.http_res")}
            </Box>

            <ShowTable
              res={true}
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: " ",
                },
                {
                  name: "data.invoiceUrl",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_153"),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <>
            <CodeSnippet
              title={translate("common.http_result")}
              code={invoice_api.response}
            />
          </>
        }
      />
    </>
  );
}
